<template>
  <div id="app" class="body">
    <div v-if="headerShow">
      <Header> </Header>
    </div>
    <router-view />
  </div>
</template>

<script>
import Header from "@/components/header.vue";
export default {
  computed: {},
  components: {
    Header,
  },
  data() {
    return {
      headerShow: true,
    };
  },
  beforeCreate() {},
  mounted() {},
  watch: {
    $route(to, from) {
      if (this.$route.path == "/login" || this.$route.path ==  "/signin" || this.$route.path ==  "/password" ) {
        this.headerShow = false;
      } else {
        this.headerShow = true;
      }
    },
  },
  methods: {},
};
</script>
<style lang="scss"></style>
